import { MyClub, Cashback, SharePoints } from '@mafc/icon';

const getLoyaltyIcon = (loyaltyIcon: string) => {
  switch (loyaltyIcon) {
    case 'MyClub':
      return MyClub;
    case 'Cashback':
      return Cashback;
    case 'SharePoints':
    default:
      return SharePoints;
  }
};

export const getLoyaltyIconSize = (loyaltyIcon: string) => {
  switch (loyaltyIcon) {
    case 'MyClub':
      return {
        width: '42px',
        height: '36px',
      };
    case 'SharePoints':
    case 'Cashback':
    default:
      return {
        width: '36px',
        height: '36px',
      };
  }
};

export default getLoyaltyIcon;
